import axios from 'axios'
import Vue from 'vue'
import { actionTypes } from "@/store/actionTypes"
import store from "@/store/store"
import AppService from '@/services/app.service'
import AuthService from '../services/auth.service'

const $http = axios.create({
    baseURL: `${process.env.VUE_APP_BASE_API_URL}`
})
$http.interceptors.request.use(
    config => {
        config.headers = {
            Authorization: `Bearer ${AuthService.getToken()}`,
            ...config.headers
        }
        return config
    },
    err => Promise.reject(err)
)
$http.interceptors.response.use(
    response => response,
    error => {
        let response = error.response
        if (!response) {
            return Promise.reject(error)
        }

        switch (response.status) {
            case 401: {
                AuthService.removeToken()
                store.dispatch(actionTypes.user.SIGN_IN)
                break
            }
            case 403: {
                window.vueapp.$router.push('/access-denied')
                break
            }
            default: {
                if (!error.config.headers['use-default-custom']) {
                    AppService.handleRequestError()(error)
                }

                return Promise.reject(error)
            }
        }
    }
)
window.$http = $http
Vue.prototype.$http = $http
export default $http
